import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const CheckIcon: FC<SvgIconProps> = props => (
	<SvgIcon
		{...props}
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 20"
		sx={[
			{ fontSize: 20, fill: 'none' },
			...(Array.isArray(props.sx) ? props.sx : [props.sx])
		]}
	>
		<path
			d="M16.275 5.34176C16.5158 5.56945 16.6564 5.88345 16.6658 6.21474C16.6751 6.54604 16.5526 6.86749 16.325 7.10843L9.24166 14.6084C9.12685 14.7298 8.9889 14.8269 8.83594 14.894C8.68298 14.9611 8.51812 14.9969 8.3511 14.9992C8.18408 15.0015 8.01828 14.9704 7.86351 14.9075C7.70874 14.8447 7.56813 14.7515 7.44999 14.6334L3.69999 10.8834C3.47919 10.6465 3.35898 10.3331 3.3647 10.0092C3.37041 9.68539 3.5016 9.37641 3.73062 9.14739C3.95964 8.91837 4.26862 8.78719 4.59245 8.78147C4.91629 8.77576 5.2297 8.89596 5.46666 9.11676L8.30832 11.9568L14.5083 5.39176C14.736 5.15092 15.05 5.01037 15.3813 5.00099C15.7126 4.99161 16.034 5.11419 16.275 5.34176Z"
			fill="currentColor"
		/>
	</SvgIcon>
);
